import { Flex } from 'antd';
import {
  useAppSelector,
  useRequestTypeFinderById,
  useStatusFinderByNum,
} from '@Hooks/index';
import { useGetHrmRequestFormQuery } from '@Store/api/basicHrmApiSlice';
import { getModalRecordKey } from '@Store/selectors/modalSelector';
import { Status } from '@Components/Base';
import fieldSource from './FieldSource';

import styles from './view-form.module.css';

const RequestViewForm: React.FC = () => {
  const { findStatus } = useStatusFinderByNum('Salary');
  const { findRequestType } = useRequestTypeFinderById('Salary');
  const requestId = useAppSelector(getModalRecordKey);
  const { data } = useGetHrmRequestFormQuery(requestId!, {
    skip: !requestId,
    refetchOnMountOrArgChange: true,
  });

  if (!data) return null;

  return (
    <Flex className={styles.viewForm} vertical>
      {fieldSource(data, findRequestType).map((item) => (
        <div className={styles.viewItem} key={item.label}>
          <span>{item.label}</span>
          {item.label === 'Status' ? (
            <Status
              className={styles.viewItemValue}
              text={findStatus(Number(item.value))?.codeDesc || ''}
            />
          ) : (
            <span className={styles.viewItemValue}>{item.value}</span>
          )}
        </div>
      ))}
    </Flex>
  );
};

export default RequestViewForm;
